import { sortBy } from 'lodash'
import _get from 'lodash/get'

const INVISIBLE_UNICODE = /[\u200B-\u200D\uFEFF\u2060\u00AD\u180E]/g

export default {
	sanitizeAuthField(value, { trim = false } = {}) {
		let sanitized = (value || '').replace(INVISIBLE_UNICODE, '')
		if (trim) sanitized = sanitized.trim()
		return sanitized
	},

	removeNonNumericCharsOMD(phone) {
		return phone.replace(/\D/g, '')
	},

	// Method to format the phone number as xxx-xxx-xxxx
	newFormatPhoneNumberOMD(phone) {
		const cleaned = ('' + phone).replace(/\D/g, '') // Remove non-numeric characters
		const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)

		if (match) {
			return `${match[2]}-${match[3]}-${match[4]}`
		}

		return phone // If it doesn't match the format, return the original
	},

	validateCallBackNumberDashed(number) {
		return !(
			!number ||
			number.length < 12 ||
			number[0] === '0' ||
			number[0] === '1'
		)
	},

	formatPhoneNumberAsStandard(number) {
		// Remove non-numeric characters
		let formatted = number.replace(/\D/g, '')

		// Add the phone number format (xxx-xxx-xxxx)
		if (formatted.length <= 3) {
			number = formatted // First part
		} else if (formatted.length <= 6) {
			number = `${formatted.slice(0, 3)}-${formatted.slice(3)}` // Second part
		} else {
			number = `${formatted.slice(0, 3)}-${formatted.slice(
				3,
				6
			)}-${formatted.slice(6, 10)}` // Final format
		}
		return number
	},

	getDraftValue(key, sid) {
		if (!key || !sid) return ''
		const drafts = JSON.parse(localStorage.getItem('saved_drafts') || '{}')
		return drafts[`${key}_${sid}`] || ''
	},

	setDraftValue(key, value, sid) {
		if (!key || !sid) return
		const drafts = JSON.parse(localStorage.getItem('saved_drafts') || '{}')
		drafts[`${key}_${sid}`] = value
		localStorage.setItem('saved_drafts', JSON.stringify(drafts))
	},

	resetDraftValues() {
		localStorage.removeItem('saved_drafts')
	},

	containNewAlphabets(msg, tmplt, minCount, maxCount) {
		const message = (msg || '').trim().replace(/\s+/g, ' ')
		const template = (tmplt || '').trim() + '\n'

		const countTotalWhitespaces = str => {
			const matches = str.match(/(\r\n)|\r|\n| /g)
			return matches ? matches.length : 0
		}

		const getWords = text =>
			text
				.replace(/[\r\n\t]+/g, ' ')
				.trim()
				.split(/\s+/)

		const messageWords = getWords((message || '').toLowerCase())
		const templateWords = getWords((template || '').toLowerCase())
		let remainingMsgWords = []
		let templateWordsMissingCount = 0
		const templateWordsCopy = [...templateWords]

		for (let i of messageWords) {
			const index = templateWordsCopy.indexOf(i)
			if (index === -1) {
				remainingMsgWords.push(i)
			} else {
				templateWordsCopy.splice(index, 1)
			}
		}

		for (let i of templateWords) {
			const index = messageWords.indexOf(i)
			if (index === -1) {
				templateWordsMissingCount++
			}
		}

		const remainingMsgChars = remainingMsgWords.join('')
		const totalWhitespacesMsg = countTotalWhitespaces(message)
		const totalWhitespacesTemplate = countTotalWhitespaces(template)

		const resultLength =
			remainingMsgChars.length +
			totalWhitespacesMsg -
			(totalWhitespacesTemplate -
				templateWordsMissingCount -
				(templateWordsMissingCount < templateWords.length ? 1 : 0))

		return resultLength >= minCount && resultLength <= maxCount
	},

	normalizeString(str) {
		return str
			.toLowerCase()
			.replace(/\r\n/g, '\n') // normalize CRLF to LF
			.replace(/\s+/g, ' ') // replace multiple whitespace (spaces, tabs, newlines) with single space
			.trim()
	},

	getSpecificCallAttributes(call, attribute, defaultValue = null) {
		const callAttributes = _get(call, 'call_attributes', [])
		const found = callAttributes?.find(
			attr => attr.internal_name === attribute
		)
		const value =
			typeof found?.value === 'string' ? found.value.trim() : found?.value
		return value ? value : defaultValue
	},

	isWMACall(call) {
		const events = call?.events || []
		const hasTransferEvent = events.some(
			event =>
				event.type === 'smart_transfer' ||
				event.type === 'external_transfer'
		)
		const isWmaEnabled = !!call?.wma_allow_reply
		const isCallCompleted = !!call?.completed_at
		return isWmaEnabled && !(isCallCompleted && hasTransferEvent)
	},

	capitalizeFirstLetter(string) {
		if (!string || typeof string !== 'string') return ''
		return string.charAt(0).toUpperCase() + string.slice(1)
	},

	sortPartners(partners = []) {
		return sortBy(partners, p =>
			p.name
				?.toLowerCase()
				.replace(/[()]/g, '') // remove brackets
				.replace(/[\s-]/g, '') // remove spaces & hyphens
				.trim()
		)
	},

	async copyToClipboard(data) {
		try {
			await navigator.clipboard.writeText(data)
			return true
		} catch (err) {
			return false
		}
	},
}
